import useSWR from 'swr';
import { ApiRoute } from 'utility/node/routes';

export const useUnreadMessageCount = () => {
  const { data, mutate } = useSWR<number>(ApiRoute.DOCUMENTS_UNREAD_COUNT);

  return { data, mutate };
};
